import { Box, Container, Flex } from '@chakra-ui/react';

import { memo } from 'react';
import { Form } from './Partials';

const Login: React.FC = (): JSX.Element => {
  return (
    <Container pos="relative" maxW="container.lg">
      <Flex minH="100vh" align="center" justify="center">
        <Box bg="white" p="4" shadow="lg" rounded="lg">
          <Form />
        </Box>
      </Flex>
    </Container>
  );
};

export default memo(Login);
